import React from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage, injectIntl } from 'react-intl';
import { getCurrentLang, getLocalizedUrl } from '../utils/languageHelper';

const Footer = props => {
    const pathname = (props.location && props.location.pathname) || (typeof window !== 'undefined' ? window.location.pathname : '/');
    const currentLang = getCurrentLang(pathname, props.intl);

    return (
        <footer className="footer mt-auto py-3">
            <div className="container">
                <span className="left">
                    <ul className="list-inline no-ad">
                        <li className="list-inline-item">
                            <a href={getLocalizedUrl('/', currentLang)} rel="nofollow">
                                <FormattedMessage id="footer.home" />
                            </a>
                        </li>
                        <li className="list-inline-item">
                            <a href={getLocalizedUrl('/terms', currentLang)} rel="nofollow">
                                <FormattedMessage id="footer.terms" />
                            </a>
                        </li>
                        <li className="list-inline-item">
                            <a href={getLocalizedUrl('/privacy', currentLang)} rel="nofollow">
                                <FormattedMessage id="footer.privacy" />
                            </a>
                        </li>
                        <li className="list-inline-item">
                            <a href={getLocalizedUrl('/about', currentLang)} rel="nofollow">
                                <FormattedMessage id="footer.about" />
                            </a>
                        </li>
                    </ul>
                </span>
                <div className="d-flex justify-content-center">
                    <span className="text-muted">textcaseconvert.com © {new Date().getFullYear()}</span>
                </div>
            </div>
        </footer>
    );
};

export default withRouter(injectIntl(Footer));